import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/pocketbasePageViewTracking';

type Props = {
  children: React.ReactNode;
};

export const PageViewTrackingProvider: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const lastTrackedRef = useRef<string | null>(null);

  useEffect(() => {
    const page = `${location.pathname}${location.search}`;

    if (lastTrackedRef.current === page) {
      return;
    }

    lastTrackedRef.current = page;
    void trackPageView(page);
  }, [location.pathname, location.search]);

  return <>{children}</>;
};
